<!--Show as modal with OK button that refresh the page -->
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="refreshsessionmodalLabel">
          {{ "refreshsession.title" | trans }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="mb-0">{{ "refreshsession.message" | trans }}</p>
      </div>
      <div class="modal-footer pt-0">
        <button type="button" class="confirm-signout btn-secondary" data-dismiss="modal" (click)="logOut()">
          {{ "refreshsession.cancel" | trans }}
        </button>
        <button
          type="button"
          class="confirm-signout btn-save"
          (click)="refreshSession()"
        ><p class="btn-save-text">{{ "refreshsession.ok" | trans }}</p>
        </button>
      </div>
    </div>
